export default {"src":"/_next/static/media/cup-icon.ba7058d4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};